import React, {useState} from 'react';

import {local} from 'lib/StorageUtil';
import {Anchor, Banner, IconButton} from '@albert-io/atomic';
import sessionStore from 'client/Session/SessionStore';
import appStore from 'client/AppStore';

const OnboardingBanner = () => {
  const userId = sessionStore.getUserId();
  const HIDE_GETTING_STARTED_STORAGE_TOKEN = `${userId}-classesHideGetStartedBanner`;

  const getStartedHidden = () => {
    if (
      local.get(HIDE_GETTING_STARTED_STORAGE_TOKEN) ||
      appStore.routerProps.location.pathname.includes('/archived')
    ) {
      return true;
    }
    return false;
  };

  const [hideGettingStarted, setHideGettingStarted] = useState(getStartedHidden());

  const closeGettingStartedBanner = () => {
    local.set(HIDE_GETTING_STARTED_STORAGE_TOKEN, true);
    setHideGettingStarted(true);
  };

  if (hideGettingStarted) {
    return null;
  }
  return (
    <Banner className='u-max-width_default u-mar-lr_auto u-mar-b_5'>
      <Banner.Icon icon={['far', 'laugh']} iconStyle='regular' style={{marginTop: '0.75em'}} />
      <div className='u-display_flex u-align-items_center'>
        <span>
          Welcome to Albert! Be sure to read about{' '}
          <Anchor
            href='https://help.albert.io/en/articles/1884980-teacher-onboarding-getting-started'
            target='_blank'
            rel='noopener noreferrer'
            inheritColor
            className='u-font-weight_bold'
            underlined
          >
            onboarding as a teacher
          </Anchor>{' '}
          or check out some of the articles below to learn how to get started.
        </span>
      </div>
      <IconButton
        className='u-mar-l_auto'
        icon='times'
        onClick={() => closeGettingStartedBanner()}
        label='Hide teacher teacher onboarding banner'
      />
    </Banner>
  );
};

export default OnboardingBanner;
